module.exports = __webpack_public_path__ + "static/media/antidoping.8ef4a230.png";